import { render, staticRenderFns } from "./MaskToolDet.vue?vue&type=template&id=5d27eaf8&scoped=true&"
import script from "./MaskToolDet.vue?vue&type=script&lang=js&"
export * from "./MaskToolDet.vue?vue&type=script&lang=js&"
import style0 from "./MaskToolDet.vue?vue&type=style&index=0&id=5d27eaf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d27eaf8",
  null
  
)

export default component.exports